import type { GroupSubscriptionModel } from '../../domain/types'
import type { BookingDetailsGroupInfoAPIResponse } from '../types'

interface GroupInfoData {
  groupName: string
  groupSize: number | null
  isGroupParticipant: boolean
  isGroupResponsible: boolean
  isGroupBooking: boolean
  groupSubscriptionModel: GroupSubscriptionModel | null
  isMasterBooking: boolean
}

export function groupInfoMapper(groupInfo?: BookingDetailsGroupInfoAPIResponse): GroupInfoData {
  const isGroupBooking = groupInfo !== undefined

  return {
    groupName: groupInfo?.groupName || '',
    groupSize: groupInfo?.groupSize ?? null,
    isGroupParticipant: groupInfo?.isGroupResponsible === false,
    isGroupResponsible: groupInfo?.isGroupResponsible === true,
    isGroupBooking,
    groupSubscriptionModel: groupInfo?.subscriptionType ?? null,
    isMasterBooking: isGroupBooking && groupInfo.masterBookingNumber === undefined,
  }
}
